import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import DateConverter from '../Tools/DateConverter';
import UtilsBufer from '../Tools/UtilsBufer';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function PrincipalAdminFormulario() {
    const {loading,setLoading} = useContext(ContextGloball)
    const [regional, setRegional] = useState('');
    const [encuestas, setEncuestas] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    function validarEstado(dato,tipo) {
        var text='',css='',border='';
        if(dato.ESTADO==='A'){
            text="APROVADO"
            css='colorVerde'
            border='bordeVerde'
        }else if(dato.ESTADO==='P'){
            text='PENDIENTE'
            css='colorAmarillo'
            border='bordeAmarillo'
        }else if(dato.ESTADO==='R'){
            text='RECHAZADO'
            css='colorRojo'
            border='bordeRojo'
        }
        if(tipo===0){
        return (
            <span className={`  ${css}`}>
                <i className="fa-solid fa-bookmark"></i> {text}
            </span>
        )
        }else{
            return border
        }
    }
    useEffect(() => {
        var reg = JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL
        if (regional === '') {
            setRegional(reg);
        }
        setLoading(true);
        fetch(`${server}/formulario/getFormularios`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: reg,'tipo':3
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setEncuestas(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
                setLoading(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }, [actualizar])
    return (
        <div>
            {loading == false && <>
                {encuestas.map((item, index) => {
                    return (
                        <div className='container-fluid py-2' key={index}>
                            <div className={`card bg-dark bg-gradient ${validarEstado(item,1)}`}>
                                <div className='card-header m-0 p-0'>
                                    <div className='container-fluid'>
                                        <div className='row row-cols-2'>
                                            <div className='col-10'>
                                                <div className='text-center text-light '>
                                                    {item.TITULO}
                                                </div>
                                            </div>
                                            <div className='col-2'>
                                                {validarEstado(item,0)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='card-body m-0 p-0'>
                                    <div className='container-fluid'>
                                        <div className='row row-cols-1 row-cols-md-2 g-1'>
                                            <div className='col col-md-10'>
                                                <textarea className='text-light bg-dark form-control form-control-sm' style={{ height: '80px' }} disabled value={UtilsBufer.getText(item.DESCRIPCION)}>
                                                </textarea>
                                                <div className='text-light'>
                                                    {`INICIA  : ${DateConverter.formatoFecha(item.FECHA_INICIO)}`}
                                                </div>
                                                <div className='text-light'>
                                                    {`FINALIZA: ${DateConverter.formatoFecha(item.FECHA_FIN)}`}
                                                </div>
                                            </div>
                                            <div className='col col-md-2'>
                                                <div className='container-fluid'>
                                                    <button className='btn btn-sm w-100 btn-warning m-0 p-0 ' >
                                                        <i className="fa-solid fa-eye fa-fade"></i> Ver Contenido
                                                    </button>
                                                    <button className='btn btn-sm w-100 btn-warning m-0 p-0 ' >
                                                        <i className="fa-regular fa-eye"></i> Ver Respuestas
                                                    </button>
                                                    <button className='btn btn-sm w-100 btn-warning m-0 p-0' >
                                                        <i className="fa-solid fa-file-pen"></i> Aprobar
                                                    </button>
                                                    <button className='btn btn-sm w-100 btn-danger m-0 p-0'
                                                        data-bs-toggle="modal" data-bs-target="#EliminarModal" >
                                                        <i className="fa-solid fa-trash"></i> Eliminar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </>
            }
        </div>
    )
}

export default PrincipalAdminFormulario
